import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { designTokens } from './design-tokens';

export const appThemePreset = definePreset(Aura, {
  primitive: {
    slate: {
      50: designTokens.color.slate[50],
      100: designTokens.color.slate[100],
      200: designTokens.color.slate[200],
      300: designTokens.color.slate[300],
      400: designTokens.color.slate[400],
      500: designTokens.color.slate[500],
      600: designTokens.color.slate[600],
      700: designTokens.color.slate[700],
      800: designTokens.color.slate[800],
      900: designTokens.color.slate[900],
    },
    emerald: {
      50: '#f0fdf4',
      100: '#dcfce7',
      200: '#bbf7d0',
      300: '#86efac',
      400: '#4ade80',
      500: '#22c55e',
      600: '#16a34a',
      700: '#15803d',
      800: '#166534',
      900: '#145231',
    },
    amber: {
      50: '#fffbeb',
      100: '#fef3c7',
      200: '#fde68a',
      300: '#fcd34d',
      400: '#fbbf24',
      500: '#f59e0b',
      600: '#d97706',
      700: '#b45309',
      800: '#92400e',
      900: '#78350f',
    },
    red: {
      50: '#fef2f2',
      100: '#fee2e2',
      200: '#fecaca',
      300: '#fca5a5',
      400: '#f87171',
      500: '#ef4444',
      600: '#dc2626',
      700: '#b91c1c',
      800: '#991b1b',
      900: '#7f1d1d',
    },
    sky: {
      50: '#E5F7FC',
      100: '#d8f5ff',
      200: '#aeeaff',
      300: '#74d9f5',
      400: '#34c5ed',
      500: '#00ACE6',
      600: '#006DB0',
      700: '#00598f',
      800: '#004b78',
      900: '#08324f',
    },
  },
  semantic: {
    primary: {
      50: '#E5F7FC',
      100: '#d8f5ff',
      200: '#aeeaff',
      300: '#74d9f5',
      400: '#34c5ed',
      500: '#00ACE6',
      600: '#006DB0',
      700: '#00598f',
      800: '#004b78',
      900: '#08324f',
    },
    surface: {
      0: '#ffffff',
      50: designTokens.color.slate[50],
      100: designTokens.color.slate[100],
      200: designTokens.color.slate[200],
      300: designTokens.color.slate[300],
      400: designTokens.color.slate[400],
      500: designTokens.color.slate[500],
      600: designTokens.color.slate[600],
      700: designTokens.color.slate[700],
      800: designTokens.color.slate[800],
      900: designTokens.color.slate[900],
    },
    success: {
      50: '#f0fdf4',
      100: '#dcfce7',
      200: '#bbf7d0',
      300: '#86efac',
      400: '#4ade80',
      500: '#22c55e',
      600: '#16a34a',
      700: '#15803d',
      800: '#166534',
      900: '#145231',
    },
    warning: {
      50: '#fff7ed',
      100: '#fff0e6',
      200: '#fed7aa',
      300: '#fdba74',
      400: '#fb923c',
      500: '#FC8A33',
      600: '#ea580c',
      700: '#c2410c',
      800: '#9a3412',
      900: '#7c2d12',
    },
    danger: {
      50: '#fef2f2',
      100: '#fee2e2',
      200: '#fecaca',
      300: '#fca5a5',
      400: '#f87171',
      500: '#ef4444',
      600: '#dc2626',
      700: '#b91c1c',
      800: '#991b1b',
      900: '#7f1d1d',
    },
    info: {
      50: '#E5F7FC',
      100: '#d8f5ff',
      200: '#aeeaff',
      300: '#74d9f5',
      400: '#34c5ed',
      500: '#00ACE6',
      600: '#006DB0',
      700: '#00598f',
      800: '#004b78',
      900: '#08324f',
    },
  },
});
